import PropTypes from 'prop-types';

import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import SortableTableComponent from '../../Table/SortableTableComponent';

import { isAdmin, toSentenceCase } from '../../../utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../../Table/constants';

import Switch from '../../Table/Switch';

const StyledHeader = styled(Box)(() => ({
  textAlign: 'center',
  paddingLeft: '1.4rem',
}));

const NPSTableComponent = ({
  notificationPreferences,
  onChange,
  onModalClose,
}) => {
  const { t } = useTransl();

  const columns = [
    {
      Header: <StyledHeader />,
      id: 'name',
      sortable: false,
      key: 'name',
      dataKey: 'name',
      ordering: 'name',
      accessor: ({ displayName, parent, name }) => (
        <Box
          component="span"
          sx={
            parent
              ? {
                  paddingLeft: '1rem',
                  '&::before': {
                    content: '"- "',
                  },
                }
              : {}
          }
        >
          {displayName ?? toSentenceCase(name)}
        </Box>
      ),
    },
    {
      Header: <StyledHeader>{t('notifications.app')}</StyledHeader>,
      id: 'push',
      sortable: false,
      dataKey: 'push',
      accessor: (entry) => (
        <Box display="flex" justifyContent="center">
          <Switch
            onChange={() => onChange({ ...entry, push: !entry.push })}
            value={entry.push}
          />
        </Box>
      ),
      show: !isAdmin(),
    },
    {
      Header: <StyledHeader>{t('notifications.email')}</StyledHeader>,
      id: 'email',
      sortable: false,
      dataKey: 'email',
      accessor: (entry) => (
        <Box display="flex" justifyContent="center">
          <Switch
            onChange={() => onChange({ ...entry, email: !entry.email })}
            value={entry.email}
            isDisabled={!entry.editableEmail}
          />
        </Box>
      ),
    },
    {
      Header: <StyledHeader>{t('notifications.text')}</StyledHeader>,
      id: 'sms',
      sortable: false,
      dataKey: 'sms',
      accessor: (entry) => (
        <Box display="flex" justifyContent="center">
          <Switch
            onChange={() => onChange({ ...entry, sms: !entry.sms })}
            value={entry.sms}
            isDisabled={!entry.editableSms}
          />
        </Box>
      ),
    },
  ];
  return (
    <>
      <SortableTableComponent
        tableId={TABLE_ID.NPSTable}
        title={t('notifications.setting')}
        defaultSort={TABLE_CONSTANTS.name}
        columns={columns}
        entries={notificationPreferences}
        pluralModelName=""
        tableDataType={null}
      />
      <Box my={2} width="16rem">
        <Button
          variant="contained"
          color="primary"
          disableElevation
          fullWidth
          onClick={() => onModalClose()}
        >
          {t('actions.done')}
        </Button>
      </Box>
    </>
  );
};

NPSTableComponent.propTypes = {
  notificationPreferences: PropTypes.instanceOf(Array),
  onChange: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
};

export default NPSTableComponent;
